import { CardProps, Card as MantineCard } from '@mantine/core'

export const Card = (props: CardProps) => <MantineCard {...props} />
